import React, { useState, useEffect, useCallback } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { useRef } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function Gallery() {
  const [images, setImages] = useState([]);
  const [page, setPage] = useState(1); // Current page
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true); // Whether more images are available

  const fetchImages = useCallback(async () => {

    if (loading || !hasMore) {
      return;
    }
  
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/images?page=${page}&limit=9`);
      if (response.ok) {
        const results = await response.json();
  
        // Check if `data` exists and is an array
        if (results.data && Array.isArray(results.data)) {
          setImages((prevImages) => [...prevImages, ...results.data]);
          setPage((prevPage) => prevPage + 1);
  
          // If fewer items than limit, it means no more images
          if (results.data.length < 9) {
            setHasMore(false);
          }
        } else {
          console.error('API response does not contain valid `data`:', results);
          setHasMore(false);
        }
      } else {
        console.error('Failed to fetch images:', response.statusText);
        setHasMore(false);
      }
    } catch (error) {
      console.error('Error fetching images:', error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  }, [page, loading, hasMore]);
  

  useEffect(() => {
    fetchImages(1);
  }, []);

  

  const useDebouncedCallback = (callback, delay) => {
    const timeoutRef = useRef(null);

    const debouncedFunction = (...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => callback(...args), delay);
    };

    return debouncedFunction;
  };

  const handleScroll = useDebouncedCallback(() => {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;

    if (scrollHeight - scrollTop <= clientHeight + 100) {
      console.log('Fetching more images...');
      fetchImages();
    }
  }, 200); // Adjust delay as needed

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return <>
      <div className="row justify-content-center pb-2" style={{ backgroundColor:"#d5f5e3" }}>
        <div className="col-md-6 col-sm-12">
          <div className="text-center text-dark">
            <b><u>See what else the community created</u></b>
          </div>
        </div>
      </div>
      <div className="row justify-content-center" style={{ backgroundColor:"#d5f5e3" }} >
        <div className="col-md-6 col-sm-12">
          <div className="gallery d-flex flex-wrap">
            {images.map((image) => (
              <div
                key={image.id}
                style={{ minWidth: '75px', width: '33.33%' }}
                className="center"
              >
                <a href={`/share/${image.id}`} target="_blank" rel="noopener noreferrer">
                  <img
                    loading="lazy"
                    src={`https://butterpuppies.s3.us-west-1.amazonaws.com/thumbnails/300px_file_${image.id}.png`}
                    className="img-thumbnail"
                    alt={image.user_prompt}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        'https://butterpuppies.s3.us-west-1.amazonaws.com/thumbnails/300px_file_placeholder.png';
                    }}
                  />
                </a>
              </div>
            ))}
          </div>
          {loading && (
            <div className="text-center">
              <Spinner animation="border" role="status" />
              <span>Loading...</span>
            </div>
          )}
        </div>
      </div>
  </>
}
